import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { objectKeysToSelectedCase } from '@app/shared/helpers';
import { isArray } from 'lodash';

@Injectable()
export class ConvertToSnakeCase implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler) {
    if (request.body instanceof FormData) {
      return next.handle(request);
    }

    if (request.body == null) {
      return next.handle(request);
    }

    const convertedBody = objectKeysToSelectedCase(
      request.body,
      'snake',
      isArray(request.body),
      true,
    );

    const copiedReq = request.clone({body: convertedBody});
    return next.handle(copiedReq);
  }
}
